<template>
  <q-stepper
    ref="stepper"
    v-model="stepNumber"
    animated
    done-color="primary"
  >
    <q-step
      :name="1"
      prefix="1"
      title=""
      :done="stepNumber > 1"
    />

    <q-step
      :name="2"
      prefix="2"
      title=""
      :done="stepNumber > 2"
    />

    <q-step
      :name="3"
      prefix="3"
      title=""
      :done="stepNumber === 3"
    />
  </q-stepper>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Stepper',
  data() {
    return {
      stepNumber: 1,
    };
  },
  computed: {
    ...mapState('application', ['step']),
  },
  watch: {
    step() {
      this.stepNumber = this.step;
    },
  },
};
</script>

<style lang="scss">
</style>
